



















import Vue from "vue";
import Component from "vue-class-component";
import { ModDownloadJobInterface, ModInterface } from "../../../../types";

@Component({
  components: {},
})
export default class ModDownloadJobs extends Vue {
  private listItems: ModDownloadJobInterface[] = [];
  private unfinishedItems: ModDownloadJobInterface[] = [];
  private page = 0;
  private itemsPerPage = 20;
  private loading = false;
  private intervalId: number = 0;

  public async mounted() {
    this.listItems = await this.getPage(this.page);
    this.unfinishedItems = this.getUnfinishedItems();

    this.intervalId = setInterval(this.refreshUnfinishedItems, 15000);

    window.addEventListener("scroll", this.handleScroll);
  }

  public beforeDestroy() {
    window.removeEventListener("scroll", this.handleScroll);
    clearInterval(this.intervalId);
  }

  public async getPage(page: number): Promise<ModDownloadJobInterface[]> {
    this.loading = true;
    const response = await this.axios.get("arma/modDownloadJobs", {
      params: {
        "sort[desc]": "created",
        "limit": this.itemsPerPage,
        "offset": page * this.itemsPerPage,
      },
    });

    this.loading = false;
    return response.data;
  }

  public getStatusIcon(status: number): string {
    switch (status) {
      case 0:
        return "mdi-clock-outline";
      case 1:
        return "mdi-progress-clock";
      case 2:
        return "mdi-check";
      case -1:
        return "mdi-alert-circle-outline";
      case -2:
        return "mdi-cancel";
      default:
        return "mdi-help";
    }
  }

  public getStatusColor(status: number): string {
    switch (status) {
      case 0:
        return "white";
      case 1:
        return "accent";
      case 2:
        return "green";
      case -1:
        return "error";
      case -2:
        return "warning";
      default:
        return "warning";
    }
  }

  private getUnfinishedItems() {
    return this.listItems.filter(
      (item) => item.status === 0 || item.status === 1
    );
  }

  private async refreshUnfinishedItems() {
    for (const item of this.unfinishedItems) {
      try {
        // Wait for the response of the current request
        const refreshedItemResponse = await this.axios.get(
          "arma/modDownloadJobs/" + item.id
        );

        const refreshedItem = refreshedItemResponse.data;

        this.listItems = this.listItems.map((listItem) =>
          listItem.id === refreshedItem.id ? refreshedItem : listItem
        );
      } catch (error) {
        this.$store.dispatch("showErrorSnackbar", `Error refreshing item with id ${item.id}.`);
        // Optionally, handle the error or continue
      }

      this.unfinishedItems = this.getUnfinishedItems();
    }
  }

  private async handleScroll() {
    const bottomOfWindow =
      window.innerHeight + window.scrollY >= document.body.offsetHeight - 10;

    if (bottomOfWindow && !this.loading) {
      const newItems = await this.getPage(++this.page);
      this.listItems = [...this.listItems, ...newItems];
      this.unfinishedItems = this.getUnfinishedItems();

      if (newItems.length === 0) {
        window.removeEventListener("scroll", this.handleScroll);
      }
    }
  }

  private async download(mod: ModInterface) {
    await this.axios.post("arma/mods/", { ...mod, force: true });
    this.page = 0;
    this.listItems = await this.getPage(this.page);
  }
}
